module.exports = __webpack_public_path__ + "img/toggle-menu-sp.b7fa24f4.svg";